import alt, { AltStoreModel } from '../../alt';
import CategoriesActions from '../actions/categories_actions';

class CategoriesStore extends AltStoreModel {
  constructor() {
    super();
    this.state = {
      categories: [],
    };

    this.bindListeners({
      handleLoaded: CategoriesActions.LOADED,
    });
  }

  handleLoaded(response) {
    this.setState({ categories: response.categories });
  }
}

export default alt.createStore(CategoriesStore, 'CategoriesStore');



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/stores/categories_store.js